import * as React from 'react';
import i18n from 'src/resources/i18n';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import TextAndTestCreateContainer from '../../containers/QuickModeTextAndTestCreate';

/**
 * QuickMode-コンテンツ作成画面
 * @param props
 */
const QuickModeTextAndTestCreate: React.FunctionComponent<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('Rakunavi_Name')} />
			<TextAndTestCreateContainer {...props} />
		</>
	);
};

export default QuickModeTextAndTestCreate;



// WEBPACK FOOTER //
// ./src/pages/quickMode/QuickModeTextAndTestCreate.tsx